


































import * as Vue from '@vue/composition-api'
import CharaOption from '@/ts/model/CharaOption'
import charaOptions from '@/ts/model/charaOptions'
import CharaDescription from '@/ts/model/CharaDescription'

const ORG_SIZE = 1382
const BASE_SCALE = 0.5

export default Vue.createComponent({
  name: 'MainChara',
  props: {
    stageScale: {
      type: Number,
      default: 1.0
    },
    x: {
      type: Number,
      default: 40
    },
    y: {
      type: Number,
      default: 50
    },
    hair: {
      type: Object,
      default: () => charaOptions.Hair1
    },
    body: {
      type: Object,
      default: () => charaOptions.Body
    },
    dress: {
      type: Object,
      default: () => charaOptions.Dress1
    },
    face: {
      type: Object,
      default: () => charaOptions.Face1
    }
  },
  setup (props) {
    const dispScale = Vue.computed(() => props.stageScale * BASE_SCALE)
    const dispSize = Vue.computed(() => props.stageScale * BASE_SCALE * ORG_SIZE)
    const description = Vue.computed(() => {
      return new CharaDescription({
        hair: props.hair ? props.hair.name : undefined,
        body: props.body ? props.body.name : undefined,
        face: props.face ? props.face.name : undefined,
        dress: props.dress ? props.dress.name : undefined,
        hasEar: true
      })
    })
    return {
      dispScale,
      dispSize,
      description
    }
  }
})
